const CREDIT_MEMO = 'credit memo'
const WRITE_OFF = 'write-off'
const INSTALMENT_PAYMENT = 'installment payment'
const PENDING_INVOICE_PAYMENT = 'pending invoice payment'
const PENDING_INSTALMENT_PAYMENT = 'pending installment payment'

// Please this is the transaction types and their UI transalations
// take care when modifying this
export const TXN_TYPES_HUMANIZED = {
  // debits
  invoice: 'invoice',
  installment: 'Instalment',
  refund: 'withdrawal',

  // credits
  payment: 'payment',
  [CREDIT_MEMO]: 'credit memo',
  loan: 'payment plan',
  [WRITE_OFF]: 'write-off',
  bonus: 'cashback',
  [INSTALMENT_PAYMENT]: 'payment',
  [PENDING_INVOICE_PAYMENT]: 'payment',
  [PENDING_INSTALMENT_PAYMENT]: 'payment'
}

export const pendingTxnTypes = [PENDING_INVOICE_PAYMENT, PENDING_INSTALMENT_PAYMENT]

export const PAYMENT_WEEKS = {
  CURRENT_WEEK: '0',
  NEXT_WEEK: '1',
  OVERDUE: 'overdue'
}

// A type of instalment with just 1 term
export const isFixedTermPayment = (transaction) => {
  if (!transaction || !transaction.payment_plan || transaction.txn_type !== 'installment') {
    return false
  }
  return transaction.payment_plan.term === 1
}

export const getProcessedPaymentPlans = (paymentPlans) => {
  const processedPaymentPlans = paymentPlans
    .map(paymentPlan => (
      {...paymentPlan,
        instalments: paymentPlan.instalments.map(i => ({
          ...i,
          amount_due: i.amount - i.amount_paid,
          txn_type: 'installment',
          txn_date: paymentPlan.created_at
        }))
      }
    ))
    .reduce((data, plan) => {
      if (plan.is_active) {
        // Note: Using plan.is_paid for filtering is no longer reliable.
        // Some payment plans have is_paid set to true, but their quickbooks_account_balance
        // still shows a positive sum, indicating outstanding amounts.

        if (plan.quickbooks_account_balance > 0) {
          data.open.push(plan)
        }

        if (plan.quickbooks_account_balance <= 0) {
          data.closed.push(plan)
        }

        data.all.push(plan)
      }
      return data
    }, { open: [], closed: [], all: [] })

  return processedPaymentPlans
}

export const sortTransactions = (transactions, sortDueDate = false) => {
  const newTransactionsList = [...transactions]

  if (!newTransactionsList.length) {
    return []
  }

  // txn_date: all transansactions except payment plan instalments
  // txn_created_at: payment plan instalments
  const cleanTransactionDate = (transaction) => {
    let sortDate = sortDueDate ? transaction.due_date : transaction.txn_date || transaction.created_at
    return new Date(sortDate).getTime()
  }

  return newTransactionsList
    .sort((a, b) => (cleanTransactionDate(b) - cleanTransactionDate(a)))
    .map(transaction => ({
      ...transaction,
      txn_date: transaction.txn_date || transaction.created_at
    }))
}
